import React from 'react'

const PDFPreview = ({ documentLink }) => {
  if (!documentLink) {
    return null
  }

  const viewerUrl = `${documentLink}#toolbar=0&scrollbar=1`

  return (
    <div className="w-full h-full">
      <iframe
        src={viewerUrl}
        className="w-full h-full"
        style={{
          border: 'none',
        }}
      />
    </div>
  )
}

export default PDFPreview
